import { render, staticRenderFns } from "./exportComparative.vue?vue&type=template&id=5194a259&"
import script from "./exportComparative.vue?vue&type=script&lang=js&"
export * from "./exportComparative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports